import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

function loadLocaleMessages() {
    const locales = require.context('#', true, /^\.\/(pt|en|fr|es)\/[^/]+\.php$/i);

    const messages = locales.keys().reduce(function (messages, key) {
        const matched = key.match(/(pt|en|fr|es)\/([^/]+)\.php$/i);

        if (!matched) {
            return messages;
        }

        const [, locale, group] = matched;

        if (!messages[locale]) {
            messages[locale] = {};
        }

        messages[locale][group] = locales(key);

        return messages;
    }, {});

    ['en', 'fr', 'es'].forEach(function (locale) {
        if (!messages[locale]) {
            messages[locale] = {...messages['pt']};
        }
    });

    return messages;
}

class LaravelFormatter {
    interpolate(message, values) {
        const sanitized = String(message || '');
        const map = Object.assign({}, values || {});

        if (/\|/.test(sanitized)) {
            return this.interpolateChoice(sanitized, map);
        }

        const keys = Object.keys(map);

        const result = keys.reduce((message, key) => {
            const value = map[key];

            return message.replace(`:${key}`, value);
        }, sanitized);

        return [result];
    }

    interpolateChoice(message, {count = 0, n = 0}) {
        const result = message.replace(/^({\d+}|\[.+?])\s*/, '')
            .replace(/\|({\d+}|\[.+?])\s*/g, '|')
            .replace(':count', Math.max(count, n));

        return [result];
    }
}

export default new VueI18n({
    locale: window.appLocale || 'pt',
    fallbackLocale: 'pt',
    formatter: new LaravelFormatter(),
    messages: loadLocaleMessages(),
});
